import { render, staticRenderFns } from "./Zones.vue?vue&type=template&id=60b60ef2&scoped=true&"
import script from "./Zones.vue?vue&type=script&lang=js&"
export * from "./Zones.vue?vue&type=script&lang=js&"
import style0 from "./Zones.vue?vue&type=style&index=0&id=60b60ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b60ef2",
  null
  
)

export default component.exports